"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleType = void 0;
var ArticleType;
(function (ArticleType) {
    ArticleType["PROGRAM"] = "program";
    ArticleType["SESSION"] = "session";
    ArticleType["ANYTIME"] = "anytime";
    ArticleType["INSTRUCTOR"] = "instructor";
    ArticleType["BASIC_INSTRUCTOR"] = "basicInstructor";
    ArticleType["PLAYLIST"] = "playlist";
})(ArticleType = exports.ArticleType || (exports.ArticleType = {}));
//# sourceMappingURL=AlgoliaArticle.js.map